import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const res = await api.get('/api/auth/me');
      if (res.data.success) {
        setUser(res.data.user);
      } else {
        localStorage.removeItem('authToken');
        setUser(null);
      }
    } catch (err) {
      if (err.response?.status === 401) {
        // 토큰 자체가 무효(만료/서명 불일치) → 토큰 제거
        localStorage.removeItem('authToken');
        setUser(null);
      } else {
        // 500(DB 오류), 네트워크 오류 → 토큰 유지, 사용자는 null (재시도 가능)
        console.warn('[Auth] fetchMe 일시 오류 — 토큰 유지:', err.response?.status || err.message);
        // 토큰은 유지하되 user는 null → AuthGate가 재시도 유도
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = useCallback((token, userData) => {
    localStorage.setItem('authToken', token);
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('authToken');
    setUser(null);
  }, []);

  const value = { user, loading, login, logout, fetchMe };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
